import getMapData from './_getMapData';

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

export default mapCacheGet;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_mapCacheGet.js
// module id = null
// module chunks = 